import { createContext, useContext } from 'react';

export type TSelectContext<T extends unknown> = {
  value?: T;
  placeholder?: string;
  onChange?: (value: T) => void;
};

export const SelectContext = createContext<TSelectContext<unknown> | null>(
  null,
);

export const useSelectContext = () => {
  const context = useContext(SelectContext);

  if (!context) throw new Error('select context not found');

  return context;
};
